require('./payrollLoanRequestOutcomeWaffer.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const sum = require('lodash/math/sum');
const get = require('lodash/object/get');
// @ utilities
const { toFirstUppercase } = require('utilities/stringHelper');
const { getFormattedString } = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;
// @ constants
const { DEFAULT_LOANS_DECIMALS_LENGTH } = require('../../../../../../loansConstants/index');

class PayrollLoanRequestOutcomeWaffer extends React.Component {

    buildElements() {
        const { currency, itemsList } = this.props;

        return itemsList.map((item, index) => {
            const key = 'payroll-loan-request-outcome-waffer' + index;
            const titleName = toFirstUppercase(get(item, 'productName', ''));
            const monthlyfee = {
                amount: get(item, 'monthlyFee', 0),
                currency: currency,
                decimalsLength: DEFAULT_LOANS_DECIMALS_LENGTH
            };

            return (
                <li key={key} className="payroll-loan-request-outcome-waffer__item-list">
                    <div className="col-md-8">
                        <span className="payroll-loan-request-outcome-waffer__span-item">
                            {titleName}
                        </span>
                    </div>
                    <div className="payroll-loan-request-outcome-waffer__container-balance col-md-4">
                        <span className="payroll-loan-request-outcome-waffer__span-item">
                            {getFormattedString(monthlyfee)}
                        </span>
                    </div>
                </li>
            );
        })
    }

    render() {
        const { className, currency, itemsList, otherOutcomesContent, sumOtherLoansAndMortgages } = this.props;
        const elements = this.buildElements();
        const css = classNames('payroll-loan-request-outcome-waffer', className);
        const sumValues = sum(itemsList, item => get(item, 'monthlyFee')) + sumOtherLoansAndMortgages;

        const summaryMonthlyFee = {
            amount: sumValues,
            currency: currency,
            decimalsLength: DEFAULT_LOANS_DECIMALS_LENGTH
        };

        return (
            <section className={css}>
                <ul className="payroll-loan-request-outcome-waffer__list">
                    <div className="payroll-loan-request-outcome-waffer__content-title-openbank">
                        <FormattedText
                            value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_openbankMonthlyOutcomes"
                            className="payroll-loan-request-outcome-waffer__title-outcomes"
                        />
                    </div>
                    {elements}
                    <div className="payroll-loan-request-outcome-waffer__content-title-others-outcome">
                        <FormattedText
                            value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_othersMonthlyOutcomes"
                            className="payroll-loan-request-outcome-waffer__title-outcomes"
                        />
                    </div>
                    {otherOutcomesContent}
                </ul>
                <div className="payroll-loan-request-outcome-waffer__outstanded-section">
                    <div className="payroll-loan-request-outcome-waffer__outstanded-content">
                        <div className="payroll-loan-request-outcome-waffer__outstanded-label">
                            {this.props.outstandedLabel}
                        </div>
                        <div className="payroll-loan-request-outcome-waffer__outstanded-text">
                            {getFormattedString(summaryMonthlyFee)}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

PayrollLoanRequestOutcomeWaffer.propTypes = {
    className: PropTypes.string,
    currency: PropTypes.string.isRequired,
    itemsList: PropTypes.array,
    outstandedLabel: PropTypes.string.isRequired,
    otherOutcomesContent: PropTypes.object.isRequired,
    sumOtherLoansAndMortgages: PropTypes.number
};

PayrollLoanRequestOutcomeWaffer.defaultProps = {
    itemsList: []
};

module.exports = PayrollLoanRequestOutcomeWaffer;
